/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import {
  schedulePage,
  getDayLabel,
  updateBookedEntertainments,
  itWasBookedItem,
  getSelectedEntertainment,
  deleteEntertainmentsInCategory,
  handleDeleteEntertainment,
  handleDeleteClashedEvent,
  deleteEntertainmentByType,
  isExistsSameEntertainment,
} from '../../utils';
import { sendActivityDetailVirtualPage } from '../../googleTagManager';
import '../entertainment/Entertainment.scss';
import EntertainmentOptions from '../entertainmentOptions/EntertainmentOptions';

const handleSaveEntertainment = async (
  selectedTimeslots,
  selectedEntertainment,
  resId,
  siteCode,
  deleteEntertainment,
  getBookedEntertainments,
  saveEntertainment,
  getAvailableEntertainments,
  history,
  quantityToBook,
  shouldRemoveEntertainmentOnOtherDay,
  selectedActivityId,
  bookedEvents,
  bookedEntertainmentsWithoutPastEvents,
) => {
  await deleteEntertainmentsInCategory({
    selectedEntertainment,
    resId,
    siteCode,
    deleteEntertainment,
    bookedEntertainmentsWithoutPastEvents,
    selectedTimeslots,
  });
  if (shouldRemoveEntertainmentOnOtherDay) deleteEntertainmentByType(deleteEntertainment, bookedEvents, resId, siteCode, 'other', selectedActivityId);
  const { activityId, date, name, slots = [] } = selectedEntertainment;
  const entertainmentsToSave = selectedTimeslots.map(({ slotId: timeSlotId }) => {
    const [{ singleDate: selectedFullDate, duration }] = slots.filter(({ code }) => code === timeSlotId);
    return {
      resId,
      siteCode,
      activityId,
      date,
      name,
      timeSlotId,
      quantity: quantityToBook,
      selectedFullDate,
      duration,
      needToReportToGTM: !itWasBookedItem(bookedEntertainmentsWithoutPastEvents, timeSlotId),
      reportType: shouldRemoveEntertainmentOnOtherDay
        || isExistsSameEntertainment(activityId, name, bookedEntertainmentsWithoutPastEvents) ? 'edit' : 'book',
    };
  });
  await saveEntertainment(entertainmentsToSave);
  await updateBookedEntertainments(resId, siteCode, getBookedEntertainments, getAvailableEntertainments);
  history.goBack();
};

const getPageTitle = (date, title) => {
  if (!date) return '';
  if (date) return getDayLabel(date);
  return title;
};

const getOptions = (selectedEntertainment = {}) => (selectedEntertainment.slots
  && selectedEntertainment.slots.length > 0 ? selectedEntertainment.slots : []);

const EntertainmentDetail = ({
  title = '',
  subTitle = '',
  entertainments,
  resId = 0,
  siteCode = '',
  getAvailableEntertainments = () => { },
  entertainmentId = '',
  bookedEntertainmentsWithoutPastEvents = [],
  shouldFetchBookedEntertainments = false,
  saveEntertainment = () => { },
  deleteEntertainment = () => { },
  getBookedEntertainments = () => { },
  shouldFetchAvailableEntertainments,
  shouldSkip,
  separatorLabel = '',
  optionTitle = '',
  bookedEvents = [],
  maxAllowedShowBookingSlots = 1,
  allBookedEntertainments = [],
  lateBookingWindowMinutes,
  overlapAllowedMinutes,
  allowLateBooking,
  preventOverlapMandatory,
  overlapCheckPoolItems = false,
  xmasCollectionActId,
  xmasExperienceActId,
  eveningShowRestrictionStartDate,
  eveningShowRestrictionEndDate,
  eveningShowRestrictionStartTime,
  eveningShowRestrictionEndTime,
  additionalEveningShowTime,
  refreshTimeInterval,
  lastConfigCheckDateTime,
  isPerPersonActivity,
  quantityToBook,
  maxQuantity,
  setSelectedNumOfGuests,
  backstopDate,
  shouldFetchBackstopDate,
  getBackstopDateFromApi,
  xmasActivityMessage,
  showRestrictionMessage,
  showRestrictId1,
  showRestrictId2
}) => {
  const history = useHistory();
  const [selectedEntertainment, setSelectedEntertainment] = useState({});
  const [checkedEntertainmentSlots, setCheckedEntertainmentSlots] = useState([]);
  const [previousNameToVirtualPage, setPreviousNameToVirtualPage] = useState('');

  useEffect(() => {
    const { name } = selectedEntertainment;
    if (name) sendActivityDetailVirtualPage(name, previousNameToVirtualPage, setPreviousNameToVirtualPage);
  }, [selectedEntertainment, previousNameToVirtualPage]);

  useEffect(() => {
    if (shouldFetchAvailableEntertainments) getAvailableEntertainments(siteCode);
  }, [
    shouldFetchAvailableEntertainments,
    getAvailableEntertainments,
    siteCode,
  ]);

  useEffect(() => {
    if (entertainments
      && entertainments.length > 0
      && entertainmentId !== ''
    ) {
      const cutsEntertainmentId = entertainmentId.split('-');
      const dateIndex = cutsEntertainmentId[0];
      if (dateIndex) {
        const filteredEvent = { ...entertainments[dateIndex].events.find(event => event.code === entertainmentId) };
        const event = getSelectedEntertainment(filteredEvent);
        setSelectedEntertainment(event);
      }
    }
    if (entertainmentId === '') {
      setSelectedEntertainment({});
      setCheckedEntertainmentSlots([]);
    }
  }, [
    setSelectedEntertainment,
    entertainments,
    setCheckedEntertainmentSlots,
    entertainmentId,
  ]);

  useEffect(() => {
    if (bookedEntertainmentsWithoutPastEvents
      && selectedEntertainment
      && selectedEntertainment.slots
      && selectedEntertainment.slots.length > 0
    ) {
      const bookedSlots = selectedEntertainment.slots
        .filter(({ code }) => {
          const bookedEntertainment = bookedEntertainmentsWithoutPastEvents.find(({ TimeSlotId: timeSlotId }) => code === timeSlotId);
          return !!bookedEntertainment;
        })
        .map(({ code }) => parseInt(code, 10));

      setCheckedEntertainmentSlots(bookedSlots);
    }
  }, [
    bookedEntertainmentsWithoutPastEvents,
    getBookedEntertainments,
    resId,
    siteCode,
    selectedEntertainment,
    setCheckedEntertainmentSlots,
    shouldFetchBookedEntertainments,
  ]);

  useEffect(() => {
    if (shouldFetchBookedEntertainments) getBookedEntertainments(resId, siteCode);
  }, [
    resId,
    siteCode,
    shouldFetchBookedEntertainments,
    getBookedEntertainments,
  ]);

  useEffect(() => {
    if (shouldSkip) history.push(schedulePage);
  }, [shouldSkip, history]);

  useEffect(() => {
    if (shouldFetchBackstopDate) getBackstopDateFromApi();
  }, [shouldFetchBackstopDate, getBackstopDateFromApi]);

  const options = getOptions(selectedEntertainment);

  return (
    <div>
      <div className="entertainment-main-container notSummaryPage">
        <div className="titles">
          <div className="title">{getPageTitle(selectedEntertainment && selectedEntertainment.date, title)}</div>
          <div className="sub-title">{(!!selectedEntertainment && selectedEntertainment.name) ? selectedEntertainment.name : subTitle}</div>
          {
            !!entertainmentId
            && !!selectedEntertainment.activityId
            && (selectedEntertainment.activityId === xmasCollectionActId || selectedEntertainment.activityId === xmasExperienceActId)
            && (
              <div className="xmas-message">{xmasActivityMessage}</div>
            )
            && (selectedEntertainment.activityId === showRestrictId1 || selectedEntertainment.activityId === showRestrictId2)
            && (
              <div className="showrestriction-message">{showRestrictionMessage}</div>
            )
          }
        </div>
        <div className="entertainments notSummaryPage">
          <EntertainmentOptions
            title={optionTitle}
            separatorLabel={separatorLabel}
            options={options}
            saveAddon={(selectedTimeslots, shouldRemoveEntertainmentOnOtherDay) => handleSaveEntertainment(
              selectedTimeslots,
              selectedEntertainment,
              resId,
              siteCode,
              deleteEntertainment,
              getBookedEntertainments,
              saveEntertainment,
              getAvailableEntertainments,
              history,
              quantityToBook,
              shouldRemoveEntertainmentOnOtherDay,
              selectedEntertainment && selectedEntertainment.activityId,
              bookedEvents,
              bookedEntertainmentsWithoutPastEvents,
            )}
            removeAddon={() => handleDeleteEntertainment(
              selectedEntertainment,
              resId,
              siteCode,
              deleteEntertainment,
              getBookedEntertainments,
              getAvailableEntertainments,
              bookedEntertainmentsWithoutPastEvents,
            )}
            removeClashedEvent={clashedEvent => handleDeleteClashedEvent(
              deleteEntertainment,
              resId,
              siteCode,
              clashedEvent,
            )}
            bookedSlotsOfThisEvent={checkedEntertainmentSlots}
            maxAllowedShowBookingSlots={maxAllowedShowBookingSlots}
            bookedEvents={bookedEvents}
            quantityToBook={quantityToBook}
            selectedEntertainment={selectedEntertainment}
            allBookedEntertainments={allBookedEntertainments}
            lateBookingWindowMinutes={lateBookingWindowMinutes}
            overlapAllowedMinutes={overlapAllowedMinutes}
            allowLateBooking={allowLateBooking}
            preventOverlapMandatory={preventOverlapMandatory}
            overlapCheckPoolItems={overlapCheckPoolItems}
            xmasCollectionActId={xmasCollectionActId}
            xmasExperienceActId={xmasExperienceActId}
            eveningShowRestrictionStartDate={eveningShowRestrictionStartDate}
            eveningShowRestrictionEndDate={eveningShowRestrictionEndDate}
            eveningShowRestrictionStartTime={eveningShowRestrictionStartTime}
            eveningShowRestrictionEndTime={eveningShowRestrictionEndTime}
            additionalEveningShowTime={additionalEveningShowTime}
            refreshTimeInterval={refreshTimeInterval}
            lastConfigCheckDateTime={lastConfigCheckDateTime}
            isItTargetCategoryForEveningShow
            isPerPersonActivity={isPerPersonActivity}
            maxQuantity={maxQuantity}
            setSelectedNumOfGuests={setSelectedNumOfGuests}
            backstopDate={backstopDate}
            getBookedEntertainments={getBookedEntertainments}
            resId={resId}
            siteCode={siteCode}
            showRestrictId1={showRestrictId1}
            showRestrictId2={showRestrictId2}
            showRestrictionMessage={showRestrictionMessage}
          />
        </div>
      </div>
    </div>
  );
};

EntertainmentDetail.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  entertainments: PropTypes.array,
  resId: PropTypes.number,
  siteCode: PropTypes.string,
  entertainmentId: PropTypes.string,
  getAvailableEntertainments: PropTypes.func,
  bookedEntertainmentsWithoutPastEvents: PropTypes.array,
  shouldFetchBookedEntertainments: PropTypes.bool,
  saveEntertainment: PropTypes.func,
  deleteEntertainment: PropTypes.func,
  getBookedEntertainments: PropTypes.func,
  shouldFetchAvailableEntertainments: PropTypes.bool,
  shouldSkip: PropTypes.bool,
  separatorLabel: PropTypes.string,
  optionTitle: PropTypes.string,
  bookedEvents: PropTypes.array,
  maxAllowedShowBookingSlots: PropTypes.number,
  allBookedEntertainments: PropTypes.array,
  lateBookingWindowMinutes: PropTypes.number,
  overlapAllowedMinutes: PropTypes.number,
  allowLateBooking: PropTypes.bool,
  preventOverlapMandatory: PropTypes.bool,
  overlapCheckPoolItems: PropTypes.bool,
  xmasCollectionActId: PropTypes.number,
  xmasExperienceActId: PropTypes.number,
  eveningShowRestrictionStartDate: PropTypes.string,
  eveningShowRestrictionEndDate: PropTypes.string,
  eveningShowRestrictionStartTime: PropTypes.string,
  eveningShowRestrictionEndTime: PropTypes.string,
  additionalEveningShowTime: PropTypes.string,
  refreshTimeInterval: PropTypes.number,
  lastConfigCheckDateTime: PropTypes.string,
  isPerPersonActivity: PropTypes.bool,
  quantityToBook: PropTypes.number,
  maxQuantity: PropTypes.number,
  setSelectedNumOfGuests: PropTypes.func,
  backstopDate: PropTypes.string,
  shouldFetchBackstopDate: PropTypes.bool,
  getBackstopDateFromApi: PropTypes.func,
  xmasActivityMessage: PropTypes.string,
  showRestrictionMessage: PropTypes.string,
  showRestrictId1: PropTypes.number,
  showRestrictId2: PropTypes.number,
};

export default EntertainmentDetail;
